import { EditCompanyOutDto, EditCompanyInDto } from '../../../types/company.dto'

export const EDIT_COMPANY = 'EDIT_COMPANY'
export const EDIT_COMPANY_SUCCESS = 'EDIT_COMPANY_SUCCESS'
export const EDIT_COMPANY_ERROR = 'EDIT_COMPANY_ERROR'
export const RESET_EDIT_COMPANY = 'RESET_EDIT_COMPANY'

export interface EditCompany {
  type: typeof EDIT_COMPANY
  payload: EditCompanyOutDto
}

export interface EditCompanySuccess {
  type: typeof EDIT_COMPANY_SUCCESS
  payload: EditCompanyInDto
}

export interface EditCompanyError {
  type: typeof EDIT_COMPANY_ERROR
  payload: string | boolean
}

export interface ResetEditCompany {
  type: typeof RESET_EDIT_COMPANY
  payload: null
}
export interface State {
  data: EditCompanyInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = EditCompany | EditCompanySuccess | EditCompanyError | ResetEditCompany
